export default __webpack_public_path__ + "static/media/Annu.a6bda38c.png";